//SelectUnitDialog
//***********************************************************************************************************************
import { Box } from "@mui/material";
import * as React from "react";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITreeNode, TreeNode } from "ui/Scripts/source/models/common/treeNode";
import { Dialog } from "../../Dialog/Dialog";
import { UiTree } from "../../Tree/UiTree";

//SelectUnitTree
export interface ISelectUnitTreeProps {
    classes?: string;
    hideDisabledIcon?: boolean;
    nodes: IIdTitleNode[];
    firstColumnTitle: string;
    selectedId: string;
    margin?: string | number;
    onClick: (id: string) => void;
}

export interface ISelectUnitTreeState {
    treeNode: ITreeNode;
    nodes: ITreeNode[];
}

export class SelectUnitTree extends React.Component<ISelectUnitTreeProps, ISelectUnitTreeState> {
    static defaultProps = {
        margin: "0 -1.5rem",
    };

    constructor(props: ISelectUnitTreeProps) {
        super(props);
        const treeNodes = TreeNode.getTreeNodes(props.nodes);
        this.state = {
            treeNode: treeNodes.length > 0 ? treeNodes[0] : null,
            nodes: treeNodes.length > 0 ? treeNodes[0].getAsList([], 0) : []
        };
    }

    handleSetCollapsed = (id: string, value: boolean) => {
        const state = this.state;
        if (!id || !state.treeNode) return;
        const treeNode = new TreeNode(state.treeNode);
        const node = treeNode.getTreeNodeById(id);
        if (!node) return;
        node.collapsed = value;
        this.setState({
            treeNode,
            nodes: treeNode.getAsList([], 0),
        });
        this.props.onClick(id);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Box sx={{ margin: props.margin }}>
                <UiTree
                    classes={props.classes}
                    firstColumnTitle={props.firstColumnTitle}
                    hideDisabledIcon={props.hideDisabledIcon}
                    nodes={state.nodes}
                    selectedId={props.selectedId}
                    isFirstNode={true}
                    onClick={props.onClick}
                    onSetCollapsed={this.handleSetCollapsed}
                />
            </Box>
        );
    }
}

//SelectUnitDialog
export interface ISelectUnitDialogProps {
    classes?: string;
    hideDisabledIcon?: boolean;
    nodes: IIdTitleNode[];
    title: string;
    firstColumnTitle: string;
    selectedId: string;
    onOk: (node: IIdTitleNode) => void;
    onCancel: () => void;
}

export interface ISelectUnitDialogState {
    selectedId: string;
}

export class SelectUnitDialog extends React.Component<ISelectUnitDialogProps, ISelectUnitDialogState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: props.selectedId
        };
    }

    handleOk = () => {
        const state = this.state;
        if (!state.selectedId) return;
        const node = IdTitleNode.getById(this.props.nodes, state.selectedId);
        if (!node) return;
        this.props.onOk(node);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="select-unit-dialog"
                title={props.title}
                onClose={props.onCancel}
                maxWidth="sm"
                body={
                    <SelectUnitTree
                        hideDisabledIcon={props.hideDisabledIcon}
                        nodes={props.nodes}
                        firstColumnTitle={props.firstColumnTitle}
                        selectedId={state.selectedId}
                        onClick={(id: string) => this.setState({ selectedId: id })}
                    />
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: props.onCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk, disabled: !state.selectedId },
                ]}
            />
        );
    }
}